import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";

import { loginUserThunk } from "../../../../../auth/authThunk"; // adjust path as needed
import { handleUserData } from "../../../../../auth/authSlice"; // adjust path
import userStore from "../../../../../zustand/userStore"; // to get setUser
import { useNavigate } from "react-router-dom"; // to get navigate

import {
  googleRegisterThunk,
  sendMobileOtpThunk,
  setIsRegistered,
  verifyMobileOtpThunk,
} from "./redux/registerSlice";
import { showLoginPopup } from "../../redux/editorSlice";
import LoaderOverlay from "../../../../../pages/LoaderOverlay";

// export default function RegisterOptions({ onStepChange }) {
export default function RegisterOptions({ onStepChange, onRegistered }) {
  const dispatch = useDispatch();

  const [uiStep, setUiStep] = useState("mobile_enter");
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const { loading } = useSelector((state) => state.register);

  const navigate = useNavigate(); // use for redirect
  const setUser = userStore.getState().setUser;

  //   const handleGoogleSuccess = (response) => {
  //     dispatch(googleRegisterThunk(response.credential));
  //   };

  // const handleGoogleSuccess = (response) => {
  //   // dispatch(googleRegisterThunk(response.credential))
  //   dispatch(
  //     googleRegisterThunk({
  //       token: response.credential,
  //       register_type: "question_paper",
  //     })
  //   )
  //     .unwrap()
  //     .then(() => {
  //       dispatch(setIsRegistered(true));
  //       onStepChange(5);
  //       alert("Registered successfully");
  //       dispatch(showLoginPopup(false));
  //     })
  //     .catch((err) => {
  //       console.error("Google registration failed:", err);
  //     });
  // };
  // After successful Google registration
  const handleGoogleSuccess = async (response) => {
    try {
      await dispatch(
        googleRegisterThunk({
          token: response.credential,
          register_type: "question_paper",
        })
      ).unwrap();

      dispatch(setIsRegistered(true));
      dispatch(showLoginPopup(false));
      onStepChange(5);

      // Proceed with existing login logic
      const resultAction = await dispatch(
        loginUserThunk({
          username: "demouserexperience@yopmail.com",
          password: "123456",
        })
      );

      if (loginUserThunk.fulfilled.match(resultAction)) {
        const user = resultAction.payload;
        setUser(user.user);
        dispatch(handleUserData(user.user));
        navigate("/createPaper");
      } else {
        alert(resultAction.payload || "Login failed");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleMobileChange = (e) => {
    const val = e.target.value;
    if (/^\d{0,10}$/.test(val)) setMobile(val);
  };

  const requestOtp = () => {
    if (mobile.length !== 10) return alert("Enter valid number");
    if (!name) return alert("Enter your name");
    dispatch(sendMobileOtpThunk({ otpType: "mobile", otpSentTo: mobile }))
      .unwrap()
      .then(() => {
        alert("OTP sent successfully");
        setUiStep("mobile_verify");
      })
      .catch(() => alert("OTP sending failed"));
  };

  const handleOtpChange = (i, v) => {
    if (!/^\d?$/.test(v)) return;
    const next = [...otpDigits];
    next[i] = v;
    setOtpDigits(next);
  };

  // const verifyOtp = () => {
  //   const otp = otpDigits.join("");
  //   if (otp.length !== 6) return alert("Enter 6 digits");

  //   dispatch(
  //     verifyMobileOtpThunk({ mobile, otp, register_type: "question_paper" })
  //   )
  //     .unwrap()
  //     .then(() => {
  //       setUiStep("mobile_verified");
  //       dispatch(setIsRegistered(true));
  //       onStepChange(5);
  //       alert("Registered successfully");
  //       dispatch(showLoginPopup(false));
  //     })
  //     .catch(() => alert("Invalid OTP"));
  // };

  const verifyOtp = async () => {
    const otp = otpDigits.join("");
    if (otp.length !== 6) return alert("Enter 6 digits");

    try {
      await dispatch(
        verifyMobileOtpThunk({
          mobile,
          name,
          city,
          otp,
          register_type: "question_paper",
        })
      ).unwrap();

      dispatch(setIsRegistered(true));
      dispatch(showLoginPopup(false));
      onStepChange(5);

      // ✅ Existing login logic moved here
      const resultAction = await dispatch(
        loginUserThunk({
          username: "demouserexperience@yopmail.com",
          password: "123456",
        })
      );

      if (loginUserThunk.fulfilled.match(resultAction)) {
        const user = resultAction.payload;
        setUser(user.user);
        dispatch(handleUserData(user.user));
        navigate("/createPaper");
      } else {
        alert(resultAction.payload || "Login failed");
      }
    } catch {
      alert("Invalid OTP");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: 5,
      }}
    >
      {loading && <LoaderOverlay />}
      <div
        style={{
          width: 330,
          padding: 20,
          borderRadius: 14,
          background: "white",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        }}
      >
        {/* ---------------- TABS ---------------- */}
        {/* <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 20,
            background: "rgba(0,0,0,0.05)",
            padding: 5,
            borderRadius: 10,
          }}
        > */}
        {/* <button
            className={uiStep === "google" ? "tab-active" : "tab"}
            onClick={() => setUiStep("google")}
          >
            Google
          </button> */}

        {/* <button
            className={uiStep.startsWith("mobile") ? "tab-active" : "tab"}
            onClick={() => setUiStep("mobile_enter")}
          >
            Mobile
          </button> */}
        {/* </div> */}

        {/* ---------------- GOOGLE LOGIN ---------------- */}
        {uiStep === "google" && (
          <div style={{ textAlign: "center" }}>
            <GoogleOAuthProvider clientId="569642493427-5s2sqd2kiti5re184pi28p0r24grre2m.apps.googleusercontent.com">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => alert("Failed")}
                shape="pill"
                size="medium"
              />
            </GoogleOAuthProvider>
          </div>
        )}

        {/* ---------------- ENTER MOBILE ---------------- */}
        {uiStep === "mobile_enter" && (
          <div style={{ textAlign: "center" }}>
            {/* <label style={{ fontSize: 13, color: "#444" }}>
              Enter Your Name
            </label> */}
            <input
              type="text"
              value={name}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  setName(value);
                }
              }}
              className="input-field"
              placeholder="Your Name"
            />
            <input
              type="text"
              value={city}
              onChange={(e) => {
                const value = e.target.value;
                setCity(value);
              }}
              className="input-field"
              placeholder="Your City"
            />
            {/* <label style={{ fontSize: 13, color: "#444" }}>
              Enter Mobile Number
            </label> */}
            <input
              type="text"
              value={mobile}
              onChange={handleMobileChange}
              className="input-field"
              placeholder="10-digit mobile"
            />
            <button onClick={requestOtp} className="action-btn">
              Send OTP
            </button>
          </div>
        )}

        {/* ---------------- ENTER OTP ---------------- */}
        {uiStep === "mobile_verify" && (
          <div style={{ textAlign: "center" }}>
            <label style={{ fontSize: 13, color: "#444" }}>Enter OTP</label>

            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
              {otpDigits.map((digit, index) => (
                <input
                  key={index}
                  className="otp-box"
                  value={digit}
                  onChange={(e) => {
                    handleOtpChange(index, e.target.value); // your existing state update

                    // --- NEW: auto move focus to next input ---
                    if (e.target.value && e.target.nextSibling) {
                      e.target.nextSibling.focus();
                    }
                  }}
                  maxLength={1}
                />
              ))}
            </div>

            <button onClick={verifyOtp} className="action-btn">
              Verify
            </button>
          </div>
        )}

        {/* ---------------- VERIFIED SUCCESS ---------------- */}
        {uiStep === "mobile_verified" && (
          <h3
            style={{
              color: "green",
              fontSize: 16,
              marginTop: 10,
              textAlign: "center",
            }}
          >
            Mobile Verified ✔
          </h3>
        )}
      </div>

      {/* ---------------- STYLES ---------------- */}
      <style>{`
        .tab {
          flex: 1;
          padding: 6px 0;
          font-size: 13px;
          border: none;
          background: transparent;
          border-radius: 8px;
          cursor: pointer;
        }

        .tab-active {
          flex: 1;
          padding: 6px 0;
          font-size: 13px;
          border: none;
          background: linear-gradient(135deg, #1093ff, #11c1ff);
          color: white;
          border-radius: 8px;
          cursor: pointer;
        }

        .input-field {
          width: 85%;
          padding: 8px;
          font-size: 14px;
          margin-top: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .action-btn {
          width: 85%;
          padding: 10px;
          font-size: 14px;
          margin-top: 14px;
          border: none;
          border-radius: 8px;
          background: linear-gradient(135deg, #1093ff, #11c1ff);
          color: white;
          cursor: pointer;
        }

        .otp-box {
          width: 36px;
          height: 40px;
          font-size: 18px;
          text-align: center;
          border-radius: 8px;
          border: 1px solid #aaa;
        }
      `}</style>
    </motion.div>
  );
}
